<script setup lang="ts">
const props = defineProps({
  criteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  wordList: {
    type: Object as PropType<string[]>,
    required: true,
  },
});
const showWordList = ref(false);
const toggleShowWordList = () => {
  showWordList.value = !showWordList.value;
};

const sortedWordList = computed(() => {
  // return props.wordList.sort((a, b) => a.localeCompare(b));
  return props.wordList;
});
</script>

<template>
  <div class="flex flex-col" v-auto-animate>
    <div class="flex flex-row items-center justify-end">
      <BaseTextButton color="secondary" @click="toggleShowWordList">
        <div class="flex flex-row items-center">
          <span class="text-sm">
            {{ showWordList ? "hide" : "show" }} word list
          </span>
        </div>
      </BaseTextButton>
    </div>
    <div
      v-if="showWordList"
      class="mt-2 p-2 border bg-light rounded text-body-2"
    >
      <span class="text-sm font-bold">Word List</span>
      <div class="flex flex-row flex-wrap gap-1">
        {{ sortedWordList.join(", ") }}
      </div>
    </div>
  </div>
</template>

<style scoped></style>
